const STATIC_PATH = '/static/img';

export const SIGN_UP_THREE_STEPS = {
    1: '',
    2: 'user-profile',
    3: 'company-profile',
};

export const SIGN_UP_SINGLE_PAGE_STEP = {
    'sign-up-single-page': 'sign-up-single-page',
};

export const ALL_STEPS = {
    ...SIGN_UP_THREE_STEPS,
    ...SIGN_UP_SINGLE_PAGE_STEP,
};

export const PLACEHOLDER_TEXTS = {
    name: 'Maria Parker',
    email: 'maria@example.com',
    password: '*********',
    phone: '021 06767-3734',
    companyName: 'Pied Piper',
};

export const COMPANY_SIZE = [{
    value: 1,
    label: 'Self-employed',
}, {
    value: 10,
    label: '1 - 10',
}, {
    value: 50,
    label: '11 - 50',
}, {
    value: 200,
    label: '51 - 200',
}, {
    value: 500,
    label: '201 - 500',
}, {
    value: 1000,
    label: '501 - 1000',
}, {
    value: 5000,
    label: '1001 - 5000',
}, {
    value: 10000,
    label: '5001 - 10000',
}, {
    value: '10001+',
    label: '10001+',
}];

export const SIGNUP_IMAGES = {
    STEP_1: {
        SRC: `${STATIC_PATH}/signup/step1img.png`,
    },
    STEP_2: {
        SRC: `${STATIC_PATH}/signup/step2img.png`,
    },
    WELCOME: {
        SRC: `${STATIC_PATH}/signup/bg_welcome.png`,
    },
    COMPANY: {
        SRC: `${STATIC_PATH}/signup/bg_company.svg`,
    },
    INTEGRATE: {
        SRC: `${STATIC_PATH}/signup/bg_integrate.svg`,
    },
    SIGN_IN: {
        SRC: `${STATIC_PATH}/signup/step0img.png`,
    },
    UPDATE_DATA: {
        SRC: `${STATIC_PATH}/signup/background-ai-1.jpg`,
    },
    JOIN_YOUR_TEAM: {
        SRC: `${STATIC_PATH}/signup/sign-up-team.png`,
    },
    SIGN_UP_SINGLE_PAGE: {
        SRC: `${STATIC_PATH}/signup/bg_single_page.png`,
    },
    RESET_PASSWORD: {
        SRC: `${STATIC_PATH}/signup/bg_reset_password.png`,
    },
};

export const LAST_STEP = Object.keys(SIGN_UP_THREE_STEPS).length;

export const TEST_ID = {
    SIGN_UP_PAGE: 'SIGN_UP_PAGE',
    SIGN_UP_USERNAME_INPUT: 'SIGN_UP_USERNAME_INPUT',
    SIGN_UP_FULL_NAME_INPUT: 'SIGN_UP_FULL_NAME_INPUT',
    SIGN_UP_PHONE_INPUT: 'SIGN_UP_PHONE_INPUT',
    SIGN_UP_PASSWORD_INPUT: 'SIGN_UP_PASSWORD_INPUT',
    SIGN_UP_COMPANY_NAME_INPUT: 'SIGN_UP_COMPANY_NAME_INPUT',
    SIGN_UP_EMPLOYEE_POSITION_INPUT: 'SIGN_UP_EMPLOYEE_POSITION_INPUT',
    SIGN_UP_COMPANY_SECTOR_INPUT: 'SIGN_UP_COMPANY_SECTOR_INPUT',
    SIGN_UP_COMPANY_SIZE_INPUT: 'SIGN_UP_COMPANY_SIZE_INPUT',
    SIGN_UP_USER_EMAIL_SUBMIT_BUTTON: 'SIGN_UP_USER_EMAIL_SUBMIT_BUTTON',
    SIGN_UP_USER_PROFILE_SUBMIT_BUTTON: 'SIGN_UP_USER_PROFILE_SUBMIT_BUTTON',
    SIGN_UP_COMPANY_PROFILE_SUBMIT_BUTTON: 'SIGN_UP_COMPANY_PROFILE_SUBMIT_BUTTON',
    SIGN_UP_SINGLE_PAGE_SUBMIT_BUTTON: 'SIGN_UP_SINGLE_PAGE_SUBMIT_BUTTON',
    SIGN_UP_AGREEMENT_LINK: 'SIGN_UP_AGREEMENT_LINK',
    TERMS_AND_PRIVACY: 'TERMS_AND_PRIVACY',
};

export const ERROR_MESSAGES = {
    INVALID_EMAIL: 'Invalid e-mail address',
    REQUIRED_EMAIL: 'E-mail address is a required field',
    INVALID_FULL_NAME: 'The input must have a valid name',
    INVALID_PHONE: 'This phone number is not valid',
    INVALID_INPUT_EMAIL: 'An e-mail is not a valid input',
    INVALID_INPUT_URL: 'A URL is not a valid input',
    INVALID_INPUT_DOES_NOT_CONTAINS_LETTER: 'The input must contain an alphabetic symbol',
    REQUIRED_NAME: 'Name is a required field',
    REQUIRED_PASSWORD: 'Password is a required field',
    INVALID_PASSWORD: 'Password must contain upper/lower case letters and numbers',
    REQUIRED_PASSWORD_CONF: 'Password confirmation is a required field',
    PASSWORDS_DONT_MATCH: 'The password fields do not match',
    // eslint-disable-next-line no-template-curly-in-string
    INVALID_PASSWORD_LENGTH: 'Password must contain at least ${min} characters',
    REQUIRED_PHONE: 'Phone number is a required field',
    REQUIRED_COMPANY_SIZE: 'Company size is a required field',
    REQUIRED_EMPLOYEE_POSITION: 'Employee position is a required field',
    REQUIRED_COMPANY_NAME: 'Company name is a required field',
    REQUIRED_COMPANY_SECTOR: 'Company sector is a required field',
    DUPLICATE_EMAIL: 'E-mail already exists',
    FEDERATED_EMAIL: "This e-mail can't be used to reset password. Please, click this link bellow to continue.",
};

export const USER_SIGN_UP_PENDING = gettext('user_sign_up_pending');
export const USER_SIGN_UP_CREATED = gettext('user_sign_up_created');

export const REGEXES = {
    URL: /(http|ftp|https):\/?\/?(([^:/\s]+)[\w-]+(\.[\w-]+)*([\w.,@?^=%&amp;:/~+#-]*[\w@?^=%&amp;/~+#-])?)?/,
    EMAIL: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@(([[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    FULL_NAME: /^(\p{Lu}|(\p{Lu}')|(\p{Lu}-)|(\p{Lu}.))+((\p{L}|(\p{L}'\p{L})|(\p{L}-\p{L})|(\p{L}.))+ ?)+$/u,
    CONTAINS_LETTER: /^(?![^a-zA-Z]+$)(?!$).*$/,
    INITIALS_LETTERS: /(^|\s|-)\S/g,
    REQUIRE_NUMBERS: '(?=.*\\d)',
    REQUIRE_LOWERCASE: '(?=.*[a-z])',
    REQUIRE_UPPERCASE: '(?=.*[A-Z])',
    REQUIRE_SYMBOLS: '(?=.*[^$*.[]{}()?-“!@#%&/,><’:;|_~`])',
};
